import React from "react";
import { useNavigate } from "react-router-dom";
import { addDays, differenceInCalendarDays, format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { CalendarDays, Lock } from "lucide-react";

const MAX = 42;

export const FreeDaysCalendar = ({ x, from, to }) => {
  const nav = useNavigate();
  if (!from) return null;
  if (x.freeDatesLocked) {
    return <div className="mt-2 text-[11px] text-slate-500 flex items-center gap-1" data-testid={`free-days-locked-${x.id}`}><Lock className="w-3 h-3"/>Accedi per vedere i giorni liberi</div>;
  }
  const start = parseISO(from);
  const total = differenceInCalendarDays(parseISO(to || from), start) + 1;
  const days = Array.from({ length: Math.min(total, MAX) }, (_, i) => format(addDays(start, i), "yyyy-MM-dd"));
  const free = new Set(x.freeDates || []);
  const open = (e, d) => { e.preventDefault(); e.stopPropagation(); nav(`/artista/${x.id}?data=${d}`); };
  return (
    <div className="mt-2" data-testid={`free-days-${x.id}`}>
      <div className="text-[11px] font-semibold text-slate-600 flex items-center gap-1 mb-1"><CalendarDays className="w-3 h-3 text-gold"/>
        <span data-testid={`free-days-count-${x.id}`}>{free.size} {free.size === 1 ? "giorno libero" : "giorni liberi"} su {total}</span></div>
      <div className="flex flex-wrap gap-1">
        {days.map((d, i) => <React.Fragment key={d}>{(i === 0 || d.endsWith("-01")) && <span data-testid={`free-days-month-${x.id}-${d.slice(0, 7)}`} className="h-9 px-1.5 rounded-md bg-navy text-gold text-[9px] font-bold uppercase flex flex-col items-center justify-center leading-tight">{format(parseISO(d), "MMM", { locale: it })}<span className="text-[8px] opacity-70">{d.slice(0, 4)}</span></span>}{free.has(d)
          ? <button type="button" onClick={(e) => open(e, d)} title={`Libero · ${format(parseISO(d), "EEEE d MMMM", { locale: it })}`} data-testid={`free-day-${x.id}-${d}`}
              className="w-8 h-9 rounded-md bg-gold text-navy text-[10px] leading-tight font-bold flex flex-col items-center justify-center hover:brightness-110 transition-[filter]">
              <span className="uppercase text-[8px]">{format(parseISO(d), "EEE", { locale: it })}</span>{format(parseISO(d), "d")}</button>
          : <span title="Non disponibile" className="w-8 h-9 rounded-md border border-slate-200 text-slate-400 text-[10px] leading-tight flex flex-col items-center justify-center">
              <span className="uppercase text-[8px]">{format(parseISO(d), "EEE", { locale: it })}</span>{format(parseISO(d), "d")}</span>}</React.Fragment>)}
        {total > MAX && <span className="text-[10px] text-slate-500 self-center">+{total - MAX} giorni</span>}
      </div>
    </div>
  );
};
